import type { ReactNode } from 'react';
import { Icon, type IconName } from '../shell/Icon.tsx';
import type { Tone } from './state.ts';
import styles from './Chip.module.css';

/* ==========================================================================
   Chip — one singular, page-level fact. Outlined, never filled.
   Budget: one per surface, two at the absolute most. If it repeats per row,
   it is not a chip.
   ========================================================================== */

export function Chip({
  children,
  tone,
  icon,
  mono = false,
  onDismiss,
  dismissLabel = 'Dismiss',
  title,
}: {
  children: ReactNode;
  tone?: Tone | undefined;
  icon?: IconName | undefined;
  mono?: boolean | undefined;
  onDismiss?: (() => void) | undefined;
  dismissLabel?: string | undefined;
  title?: string | undefined;
}) {
  return (
    <span
      className={styles.chip}
      data-tone={tone}
      data-toned={tone !== undefined}
      data-mono={mono}
      title={title}
    >
      {icon !== undefined && (
        <span className={styles.glyph}><Icon name={icon} size={12} /></span>
      )}
      {children}
      {onDismiss !== undefined && (
        <button
          type="button"
          className={styles.dismiss}
          onClick={onDismiss}
          aria-label={dismissLabel}
        >
          <Icon name="close" size={10} />
        </button>
      )}
    </span>
  );
}
